module.exports = "/_next/static/images/9db45540190d91473b2542f2b53b1840-credit-card-lg.svg";